import { useMemo } from "react";

import Bowser from "bowser";

import {
  EXTENSION_BROWSER_BY_UA_NAME,
  EXTENSION_STORE_URL_BY_BROWSER,
} from "./use-extension-store.constants";
import { IExtensionStore } from "./use-extension-store.models";

/**
 * Resolves which extension store listing to show the visitor: reads the
 * browser off the user-agent (`bowser`), maps it to a browser we publish for,
 * and hands back that listing's URL. `isSupported` is false for every browser
 * we do not ship to yet — the /extension guide and the login banner then show
 * a "not available for your browser" note instead of the install steps. See
 * ai/docs/kep-signing.md.
 *
 * The user-agent does not change while the tab is open, so this resolves once.
 */
export const useExtensionStore = (): IExtensionStore =>
  useMemo(() => {
    const uaName =
      typeof navigator === "undefined"
        ? ""
        : Bowser.getParser(navigator.userAgent).getBrowserName(true);
    const browser = EXTENSION_BROWSER_BY_UA_NAME[uaName] ?? null;

    return {
      browser,
      url: browser ? EXTENSION_STORE_URL_BY_BROWSER[browser] : undefined,
      isSupported: browser !== null,
    };
  }, []);
